function usageType(key, name) {
    return {
        key: key,
        name: name
    };
}

export default function usagetypes() {
    return {
        business: usageType('business_signedup', 'Business'),
        personal: usageType('personal_signedup', 'Personal'),
        education: usageType('education_signedup', 'Education')
    };
}



// WEBPACK FOOTER //
// ./data/services/usage-types.js